export default theme => ({
    '@global': {
        '@media screen and (max-width: 320px)': {
            '.root': {
                backgroundColor: '#FFFFFF',
                height: 'auto'
            }
        }
    },
    button: {
        '&.MuiButton-root': {
            backgroundColor: '#003168',
            borderRadius: '2px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: '#ffffff',
            float: 'right',
            fontSize: '12px',
            fontWeight: 400,
            height: '35px',
            justifyContent: 'center',
            letterSpacing: '0.07px',
            lineHeight: '12px',
            marginBottom: '15px',
            minWidth: '80px',
            width: 'fit-content'
        }
    },
    buttonContainer: {
        display: 'flex',
        marginTop: '1rem'
    },
    gridContainerCenter: {
        '@media screen and (max-width: 431px)': {
            height: 'auto',
            width: 'fit-content'
        },
        display: 'flex',
        height: '260px',
        justifyContent: 'center',
        marginTop: theme.spacing(4),
        width: '725px'
    },
    gridContainerCentre: {
        '@media screen and (max-width: 431px)': {
            minHeight: 'auto',
            width: '100%'
        },
        backgroundColor: '#eeeeee',
        display: 'flex',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 326px)',
        width: '100%'
    },
    heading: {
        color: theme.palette.error.main
    },
    link: {
        alignSelf: 'start',
        fontsize: theme.typography.body2.fontSize
    },
    registrationRoot: {
        padding: theme.spacing(4, 4, 4, 4)
    },
    verbiage: {
        color: 'rgba(0,0,0,0.54)',
        fontSize: '16px',
        fontWeight: '300',
        letterSpacing: '0',
        lineHeight: '24px',
        paddingTop: '16px'
    }
})
